import { render, staticRenderFns } from "./scrollBtn.vue?vue&type=template&id=74470129&scoped=true&"
import script from "./scrollBtn.vue?vue&type=script&lang=js&"
export * from "./scrollBtn.vue?vue&type=script&lang=js&"
import style0 from "./scrollBtn.vue?vue&type=style&index=0&id=74470129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74470129",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('74470129', component.options)
    } else {
      api.reload('74470129', component.options)
    }
    module.hot.accept("./scrollBtn.vue?vue&type=template&id=74470129&scoped=true&", function () {
      api.rerender('74470129', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/scrollBtn.vue"
export default component.exports